import { forwardRef } from "react";

import {
  PAGINATION_LINK_ACTIVE_CLASS,
  PAGINATION_LINK_BASE_CLASS,
  type TPaginationLinkProps,
} from "@/ui/components/navigation/Pagination/Pagination.config";
import { cn } from "@/ui/lib/utils";

export const PaginationLink = forwardRef<HTMLButtonElement, TPaginationLinkProps>(
  (
    {
      isActive = false,
      className,
      type = "button",
      children,
      ...props
    },
    ref,
  ) => (
    <button
      {...props}
      ref={ref}
      type={type}
      data-component="PaginationLink"
      aria-current={isActive ? "page" : undefined}
      className={cn(
        PAGINATION_LINK_BASE_CLASS,
        isActive && PAGINATION_LINK_ACTIVE_CLASS,
        className,
      )}
    >
      { children }
    </button>
  ),
);

PaginationLink.displayName = "PaginationLink";
